import type { MessageInfo } from '@lub0v/santa-utils';

export async function organizerMessages(key: string, organizerId: number, body?: { message: string; attachment?: unknown }) {
  const response = await fetch(`/api/box/${encodeURIComponent(key)}/organizer/${organizerId}/messages`, {
    method: body ? 'POST' : 'GET', credentials: 'same-origin',
    ...(body ? { headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) } : {}),
  });
  if (!response.ok) return { ok: false, data: undefined, error: { message: 'game.messenger.sendFailed' } };
  return { ok: true, data: await response.json() as MessageInfo[], error: undefined };
}
